export default {
    computed: {
      
        filtersApplied() {
            if (this.filters.selectedGroups.length > 0 || this.filters.selectedTags.length > 0 || this.filters.estimation !== 'Any') {
                return true
            }
        
            return false
        }
    },
}
